import $  from 'jquery';
import "babel-polyfill";
import Utils from 'medscape/utils';
import Handlebars from 'handlebars';
import Tracking from 'medscape/tracking';
import PageContent from 'infosite/page-content';
import ShareWidget from 'medscape/share-widget';
import GiftManager from 'medscape/gift-manager';
import InfoSiteHelpers from 'infosite/helpers';
import MetaDataModule from 'infosite/page-content/meta-data-tags';
window.$ = window.$ || $;
window.jQuery = window.jQuery || $;
window.Handlebars = window.Handlebars || Handlebars;

(function(app,infosite){
	infosite = infosite || {};
	infosite.templates = infosite.templates || {};
	const cache = window.medscape.config.cache;

	const staticPath = `${app.config.staticServer.host}${app.config.staticServer.path}`;
	let cssFile = 'infosite-desktop.css';

	let $infositeApp = $('#infosite-app');
	let isStylesLoaded = window.medscape.isStylesLoaded || false;
	if((document.location.hostname.indexOf('localhost')>-1) && Utils.isMobile()){
		cssFile = 'infosite-mobile.css';
		window.medscape.isMobile = true;
	}
	const cssPath = `${staticPath}/css/${cssFile}?v=${cache}`;
	if(!isStylesLoaded){
		$("<link/>", {
		   rel: "stylesheet",
		   type: "text/css",
		   href: cssPath,
		   onLoad: ()=>{
		   }
		}).appendTo("head");
	}


	function getTemplate($el){
		let template = $el.find('.template').html();
		return Handlebars.compile(template);
	}

	$(document).ready(function(){
		Tracking.init(infosite.config["tracking"]);
		$('body').addClass(window.medscape.isMobile ? 'medscape-mobile' : 'medscape-desktop');

		let $headerEl = $('header');
		let $footerEl = $('footer');
		let headerConfig = infosite.config.header;
		let footerConfig = infosite.config.footer;
		const ServerData = {
			static:{
				host: app.config.staticServer.host,
				path: staticPath
			}
		};
		const ConfigPropData = {
			ServerData: ServerData
		};

		if(!infosite.config.header.desktop.isResponsive && !Utils.isMobile()){
			//$('.responsive-component').removeClass('responsive-component');
			$('body').addClass('not-responsive');
		}

		(function loadHeader(){

			let template = infosite.templates.header = getTemplate($headerEl);
			let featureTemplate = headerConfig.feature.headline;
			let inviteMessageTemplate = headerConfig.feature.inviteMessage;

			for (let prop in headerConfig.medscape) {
			    if (headerConfig.medscape.hasOwnProperty(prop)) {
			        headerConfig.medscape[prop] = Handlebars.compile(headerConfig.medscape[prop])(ConfigPropData);
			    }
			}
			for (let prop in headerConfig.infosite) {
			    if (headerConfig.infosite.hasOwnProperty(prop)) {
			        headerConfig.infosite[prop] = Handlebars.compile(headerConfig.infosite[prop])(ConfigPropData);
			    }
			}
			headerConfig.ServerData = ServerData;
			headerConfig.feature.headline = Handlebars.compile(featureTemplate)(headerConfig);
			headerConfig.feature.inviteMessage = Handlebars.compile(inviteMessageTemplate)(headerConfig);

			let html = template(headerConfig);
			let $html = $(html);
			$headerEl.html($html);

			if(headerConfig.feature.backgroundImage && headerConfig.feature.backgroundImage.length>0){
				let bgUrl = headerConfig.feature.backgroundImage.startsWith('//') ? headerConfig.feature.backgroundImage : staticPath + headerConfig.feature.backgroundImage;
				let bgImage = `url(${bgUrl})` ;

				$html.find('.feature-row').css('background-image',bgImage);
			}

			if(!window.medscape.isMobile && headerConfig.desktop.isSticky){
				InfoSiteHelpers.loadStickyHeader();
			}
			else if(window.medscape.isMobile && headerConfig.mobile.isSticky){
				InfoSiteHelpers.loadStickyHeader();
			}
		})(); // loadHeader
		(function loadFooter(){
			let template = infosite.templates.footer = getTemplate($footerEl);
			for (let prop in footerConfig) {
				if (footerConfig.hasOwnProperty(prop)) {
					footerConfig[prop] = Handlebars.compile(footerConfig[prop])(ConfigPropData);
				}
			}
			footerConfig.ServerData = ServerData;
			let html = template(footerConfig);
			let $html = $(html);
			$footerEl.html($html);
		})(); // loadFooter

		(function loadModules(){
			if(!infosite.config["comment"].isActive){
				$('.social-sharing-widget-container .comments-wrap').hide();
			}
			MetaDataModule.init();
			PageContent.init(infosite.config["pages"],infosite.config["navigation"],infosite.config["isi"]);
			InfoSiteHelpers.load();
		})(); // loadModules
		//Tracking.trackContainerLinks($('body')[0]);
	}); // document ready


})(window.medscape,window.infosite);



// WEBPACK FOOTER //
// ./src/app/infosite-app.js